<!--
 * @Author: ezhizao 庄德政
 * @LastEditors: ezhizao 庄德政
 * @Description: 
-->
<template>
  <div class="main-container scrollbar-y">
    <div class="page-header">
      <div class="page-title">设备管理</div>
    </div>
    <div class="page-body">
      <el-row :gutter="20">
        <el-col :span="7">
          <el-tabs>
            <el-tab-pane label="设备类别管理">
              <el-button size="mini" type="primary" round v-on:click="handlerEditCategory(null)"><i class="el-icon-plus"></i> 添加类别</el-button>
              <el-table ref="categoriesTable" :data="categoryList" size="mini" highlight-current-row border header-row-class-name="datalist-header" row-key="id" default-expand-all :tree-props="{children: 'children'}" @current-change="handlerCategoryChange" style="width: 100%; margin-top: 3px;">
                <el-table-column type="index" label="序号" width="45" align="center"></el-table-column>
                <el-table-column prop="name" label="类别名称" header-align="center"></el-table-column>
                <el-table-column prop="sort" label="排序" align="center" width="45"></el-table-column>
                <el-table-column label="操作" width="100" align="center">
                  <template v-slot:default="scope">
                    <el-button size="mini" type="warning" circle v-on:click="handlerEditCategory(scope.row)"><i class="el-icon-edit"></i></el-button>
                    <el-button size="mini" type="danger" circle v-on:click="handlerDeleteCategory(scope.$index, scope.row)"><i class="el-icon-delete"></i></el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
        </el-col>
        <el-col :span="17">
          <el-tabs>
            <el-tab-pane label="设备管理"><!--设备管理-->
              <el-button size="mini" type="primary" round v-on:click="handlerEdit(0)"><i class="el-icon-plus"></i> 添加设备</el-button>
              <el-table :data="dataList" size="mini" border header-row-class-name="datalist-header" style="width: 100%; margin-top: 3px;">
                <el-table-column type="index" label="序号" width="45" align="center"></el-table-column>
                <el-table-column prop="name" label="设备名称" header-align="center"></el-table-column>
                <el-table-column prop="manufacturer" label="生产厂商" width="150" align="center"></el-table-column>
                <el-table-column prop="standard" label="规格" width="150" align="center"></el-table-column>
                <el-table-column label="加工范围(mm)" width="150" align="center">
                  <template v-slot:default="scope">{{scope.row.X}} * {{scope.row.Y}} * {{scope.row.Z}}</template>
                </el-table-column>
                <el-table-column prop="number" label="设备数量" width="90" align="center"></el-table-column>
                <el-table-column prop="sort" label="排序" width="50" align="center"></el-table-column>
                <el-table-column label="操作" width="100" align="center">
                  <template v-slot:default="scope">
                    <el-button size="mini" type="warning" circle v-on:click="handlerEdit(scope.row.id)"><i class="el-icon-edit"></i></el-button>
                    <el-button size="mini" type="danger" circle v-on:click="handlerDelete(scope.$index, scope.row)"><i class="el-icon-delete"></i></el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination style="margin-top: 20px;" v-on:size-change="handlerSizeChange" v-on:current-change="handlerCurrentChange" :current-page="query.pn" :page-sizes="[15, 30, 50, 100]" :page-size="query.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCount"></el-pagination>
            </el-tab-pane>
          </el-tabs>
        </el-col>
      </el-row>
    </div>
    <el-dialog :visible="categoryDialogIsShow" width="400px" :close-on-click-modal="false" :modal-append-to-body="false" :append-to-body="true" :show-close="false">
      <div slot="title" class="dialog-title-container">
        <span class="title-label"><i class="el-icon-document"></i> 设备类别</span>
        <i style="float:right;" class="el-icon-error" @click="categoryDialogIsShow=false"></i>
      </div>
      <div class="dialog-search-container">
        <el-form label-width="80px">
          <el-form-item label="父级类别">
            <el-cascader size="mini" v-model="parentIds" :options="categoryOptions" :props="{ checkStrictly: true }" style="width: 100%;"></el-cascader>
          </el-form-item>
          <el-form-item label="类别名称">
            <el-input size="mini" placeholder="类别名称" v-model="category.name" clearable></el-input>
          </el-form-item>
          <el-form-item label="排序">
            <el-input-number size="mini" v-model="category.sort" controls-position="right" :min="1" style="width: 100%;"></el-input-number>
          </el-form-item>
          <el-form-item label="">
            <el-button size="small" type="success" icon="el-icon-finished" @click="handlerSaveCategory">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import apis from './module.apis.js'
export default {
  name: 'website_equipment_list',
  data: () => {
    return {
      query: {
        currentCategoryId: '0',
        keywords: '',
        pageSize: 15,
        pn: 1
      },
      categoryDialogIsShow: false,
      dataList: [],
      pageCount: 0,
      totalCount: 0,
      // 类别列表
      categoryList: [],
      categoryOptions: [],
      // 类别数据
      category: {},
      categoryIds: '0',
      emptyCategory: {
        id: '0',
        parent_id: '0',
        parent_ids: '',
        name: '',
        value: '0',
        label: '',
        sort: 1
      },
      parentIds: ['0']
    }
  },
  mounted: function () {
    this.loadCategories()
  },
  methods: {
    loadCategories: function () {
      const _this = this
      _this.post(apis.getEquipmentCategories, {}, function (res) {
        const _json = res.data
        _this.categoryList = _json.categoryList
        // 设置默认第一行类别选中
        _this.$refs.categoriesTable.setCurrentRow(_this.categoryList[0])
      })
    },
    loadData: function () {
      const _this = this
      _this.post(apis.getEquipments, _this.query, function (res) {
        const _json = res.data
        _this.dataList = _json.dataList
        _this.pageCount = _json.totalPageCount
        _this.totalCount = _json.totalCount
        _this.query.pn = _json.pn
      })
    },
    handlerSearch: function () {
      this.loadData()
    },
    handlerSizeChange: function (pageSize) {
      this.query.pn = 1
      this.query.pageSize = pageSize
      this.loadData()
    },
    handlerCurrentChange: function (pageIndex) {
      this.query.pn = pageIndex
      this.loadData()
    },
    // 编辑
    handlerEdit: function (_id) {
      this.$router.replace({
        path: '/equipment/form/' + _id + '/' + this.categoryIds
      })
    },
    // 删除 设备、单页面
    handlerDelete: function (_index, _row) {
      const _this = this
      _this.$confirm('此操作将删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.post(apis.delEquipments, { ids: _row.id }, function (res) {
          const _json = res.data
          if (_json.status === 'ok') {
            _this.$message({
              message: '操作成功',
              type: 'success'
            })
            _this.loadData()
          } else {
            _this.$message.error('操作失败')
          }
        })
      })
    },
    // 编辑类别
    handlerEditCategory: function (_row) {
      const _this = this
      _this.post(apis.getEquipmentCategory, { id: _row === null ? '0' : _row.id }, function (res) {
        const _json = res.data
        const rootCategory = JSON.parse(JSON.stringify(_this.emptyCategory))
        rootCategory.label = '一级分类'
        _this.categoryOptions = _json.categoryOptions
        _this.categoryOptions.unshift(rootCategory)
        
        if (_row === null)
          _this.category = JSON.parse(JSON.stringify(_this.emptyCategory))
        else {
          _this.category = _row
          _this.parentIds = _this.category.parent_ids.split(',')
        }
        _this.categoryDialogIsShow = true
      })
    },
    handlerDeleteCategory: function (_index, _row) {
      const _this = this
      _this.$confirm('此操作将删除该类别, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.post(apis.delEquipmentCategories, { ids: _row.id }, function (res) {
          const _json = res.data
          if (_json.status === 'ok') {
            _this.$message({
              message: '操作成功',
              type: 'success'
            })
            _this.loadCategories()
          } else {
            _this.$message.error('操作失败')
          }
        })
      })
    },
    // 保存类别
    handlerSaveCategory: function (_id) {
      const _this = this
      const _length = _this.parentIds.length
      if (_length > 0) {
        _this.category.parent_id = _this.parentIds[_length - 1]
        _this.category.parent_ids = _this.parentIds.join(',')
      }
      _this.post(apis.saveEquipmentCategory, _this.category, function (res) {
        const _json = res.data
        if (_json.status === 'ok') {
          _this.$message({
            message: '操作成功',
            type: 'success'
          })
          _this.loadCategories()
          _this.categoryDialogIsShow = false
        } else {
          _this.$message.error('操作失败')
        }
      })
    },

    /*
     * 点击类别行
     */
    handlerCategoryChange: function (_row) {
      if(_row !== null) {
        this.categoryIds = _row.parent_ids === '0' ? _row.id : (_row.parent_ids +','+_row.id)
        this.query.currentCategoryId = _row.id
        this.loadData()
      }
    }
  }
}
</script>